var vs = document.querySelectorAll(".variant-select");
for (let i = 0; i < vs.length; i++) {
  const select = vs[i];
  var avaliable = select.querySelectorAll(".link_anchor.available");
  for (let i = 0; i < avaliable.length; i++) {
    avaliable[0].classList.add("active");
  }
}

function quickATC(e) {
  var pcard = e.parentElement;
  var variants = pcard.querySelector(".variant-select");
  console.log(pcard);
  var allCards = document.querySelectorAll(".product-grid-item");
  for (let i = 0; i < allCards.length; i++) {
    const element = allCards[i];
    element.querySelector(".variant-select").classList.remove("active");
  }
  variants.classList.add("active");
}

/* Card Variant Change */
function cardVariant(e, parent, val) {
  var cardForm = parent;
  var cardId = cardForm.querySelector(".card__form select");
  var variantSibs = e.parentNode.querySelectorAll("*");
  for (var i = 0; i < variantSibs.length; i++) {
    variantSibs[i].classList.remove("active");
  }
  e.classList.add("active");
  cardForm.classList.add("active");
  cardId.value = val;
}

function closThis(e) {
  e.parentElement.classList.remove("active");
}

// gift wrapping

const giftWrapCheckbox = document.querySelectorAll(".gift-wrap-checkbox");
for (let i = 0; i < giftWrapCheckbox.length; i++) {
  giftWrapCheckbox[i].addEventListener("change", function () {
    const isChecked = this.checked;

    // Send an AJAX request to update the cart
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          gift_wrap: isChecked ? "Yes" : "No",
        },
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        console.log("Gift wrap updated:", cart);
      })
      .catch((error) => console.error("Error updating gift wrap:", error));
  });
}
document.querySelector(".gift-wrap-checkbox");

document.addEventListener("DOMContentLoaded", function () {
  // Fetch the current cart state
  fetch("/cart.js", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => response.json())
    .then((cart) => {
      // Check if the gift_wrap attribute is set
      const giftWrapSelected =
        cart.attributes && cart.attributes.gift_wrap === "Yes";

      // Set the checkbox state
      const giftWrapCheckbox = document.querySelector(".gift-wrap-checkbox");
      if (giftWrapCheckbox) {
        giftWrapCheckbox.checked = giftWrapSelected;
      }
    })
    .catch((error) => console.error("Error fetching cart data:", error));
});

const cartToggle = document.querySelectorAll(".cart-toggle");
for (let i = 0; i < cartToggle.length; i++) {
  cartToggle[i].addEventListener("click", function () {
    const body = document.querySelector("body");
    if (body) {
      body.classList.toggle("cart-open");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var checkboxes = document.querySelectorAll(".cart-checkbox");
  var checkoutBtns = document.querySelectorAll('button[name="checkout"]');

  function updateCheckboxesAndButtons(triggeredCheckbox) {
    // Set all .cart-checkbox to the same checked state as the one clicked
    checkboxes.forEach(function (cb) {
      cb.checked = triggeredCheckbox.checked;
    });

    // Enable/disable all checkout buttons based on checked state
    checkoutBtns.forEach(function (btn) {
      if (triggeredCheckbox.checked) {
        btn.removeAttribute("disabled");
      } else {
        btn.setAttribute("disabled", "disabled");
      }
    });
  }

  // Attach event listeners to all .cart-checkbox
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", function () {
      updateCheckboxesAndButtons(checkbox);
    });
  });

  // On load, ensure all checkboxes and buttons are in sync with the first checkbox (if any)
  if (checkboxes.length > 0) {
    updateCheckboxesAndButtons(checkboxes[0]);
  }
});



// filters modal!
const filterToggle = document.querySelectorAll(".filter-toggle");
if (filterToggle !== null) {
  for (let i = 0; i < filterToggle.length; i++) {
    filterToggle[i].addEventListener("click", function () {
      const filtersModal = document.querySelector(".filters-modal");
      const filtersModalOverlay = document.querySelector(".filters-modal-overlay");
      filtersModal.classList.toggle("active");
      filtersModalOverlay.classList.toggle("active");
    });
  }
}
// Collection menu
const collectionMenuToggle = document.querySelectorAll(".expand-menu-btn");
if (collectionMenuToggle !== null) {
  for (let i = 0; i < collectionMenuToggle.length; i++) {
    collectionMenuToggle[i].addEventListener("click", function () {
      const collectionMenu = document.querySelector(".collection-menu");
      collectionMenu.classList.toggle("active");
      if (collectionMenu.classList.contains("active")) {
        document.querySelector(".expand-menu-btn.exp").classList.add("hide");
        gsap.to(collectionMenu, {
          height: "auto",
          duration: 0.3,
          ease: "power2.inOut"
        });
      } else {
        document.querySelector(".expand-menu-btn.exp").classList.remove("hide");
        gsap.to(collectionMenu, {
          height: "20px",
          duration: 0.3,
          ease: "power2.inOut"
        });
      }
    });
  }
}

// PDP size selector
const myDetails = document.querySelectorAll(".details");
if (myDetails !== null) {
  for (let i = 0; i < myDetails.length; i++) {
    const detail = myDetails[i];
    const fieldset = detail.querySelector("fieldset");
    detail.querySelector('.summary').addEventListener("click", function () {
      detail.classList.toggle("active");
      if (detail.classList.contains("active")) {
        detail.querySelector(".chevron-down").style.display = "none";
        detail.querySelector(".chevron-up").style.display = "block";
        gsap.to(fieldset, {
          height: "auto",
          duration: 0.3,
          ease: "power2.inOut"
        });
      } else {
        detail.querySelector(".chevron-down").style.display = "block";
        detail.querySelector(".chevron-up").style.display = "none";
        gsap.to(fieldset, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut"
        });
      }
    });
    detail.querySelectorAll('.product_select label').forEach(function (label) {
      label.addEventListener("click", function () {
        detail.classList.toggle("active");
        detail.querySelector(".summary-text").innerHTML = this.innerHTML;
        detail.querySelector(".chevron-down").style.display = "block";
        detail.querySelector(".chevron-up").style.display = "none";
        gsap.to(fieldset, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut"
        });
        console.log(fieldset)
      });
    });
  }
}
// Colour picker
const pickers = document.querySelectorAll(".w-picker");
if (pickers !== null) {

  const colourName = document.querySelector(".color_name");
  for (let i = 0; i < pickers.length; i++) {
    pickers[i].addEventListener("mouseenter", function () {
      console.log(pickers[i].getAttribute("data-name"));
      colourName.innerHTML = pickers[i].getAttribute("data-name");
    });
    pickers[i].addEventListener("mouseleave", function () {
      colourName.innerHTML = colourName.getAttribute("data-colour-name");
    });
  }

}


// pdp deets
const deets = document.querySelectorAll(".pdp-deet");
if (deets !== null) {
  for (let i = 0; i < deets.length; i++) {
    const deet = deets[i];
    const fieldset = deet.querySelector(".dropdown");
    deet.querySelector('.summary').addEventListener("click", function (event) {
      event.stopPropagation();

      const isOpening = !deet.classList.contains("open");

      if (isOpening) {
        // Close all other deets first
        for (let j = 0; j < deets.length; j++) {
          if (deets[j] !== deet) {
            deets[j].classList.remove("open");
            if (deets[j].querySelector(".chevron-down")) deets[j].querySelector(".chevron-down").style.display = "block";
            if (deets[j].querySelector(".chevron-up")) deets[j].querySelector(".chevron-up").style.display = "none";
            const otherFieldset = deets[j].querySelector(".dropdown");
            if (otherFieldset) {
              gsap.to(otherFieldset, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut"
              });
            }
          }
        }
      }

      deet.classList.toggle("open", isOpening);
      if (isOpening) {
        if (deet.querySelector(".chevron-down")) deet.querySelector(".chevron-down").style.display = "none";
        if (deet.querySelector(".chevron-up")) deet.querySelector(".chevron-up").style.display = "block";
        gsap.to(fieldset, {
          height: "auto",
          duration: 0.3,
          ease: "power2.inOut"
        });
      } else {
        if (deet.querySelector(".chevron-down")) deet.querySelector(".chevron-down").style.display = "block";
        if (deet.querySelector(".chevron-up")) deet.querySelector(".chevron-up").style.display = "none";
        gsap.to(fieldset, {
          height: 0,
          duration: 0.3,
          ease: "power2.inOut"
        });
      }
    });
  }
}